import { createContext } from "react";

export const OdysseeNavigationContext = createContext(null);
